module.exports = __webpack_public_path__ + "static/media/AgremmentVencido.e4e1efe9.svg";